<template>
    <Structure_TabsRight class="interactive-image">
        <template v-slot:header>
            <InteractiveImage_Header
                :interactiveImage="interactiveImage"
                :save-state="saveState"
                @undo="undo"
                @redo="redo"
            ></InteractiveImage_Header>
        </template>
        <template v-slot:content>
            <InteractiveImage_Content
                :interactiveImage="interactiveImage"
                :loading="loadingData"
            ></InteractiveImage_Content>
        </template>
        <template v-slot:tabs>
            <div class="volets">
                <div class="volet" v-for="(volet,key) in interactiveImage.volets.get()" :key="key" :class="interactiveImage.volets.isActive(key) ? 'active' : ''"
                     @click="voletSetActive(key)">
                    <div class="text">{{ $t(volet.label) }}</div>
                </div>
            </div>
            <InteractiveImage_Labels
                v-if="interactiveImage.volets.isActiveComponent('InteractiveImage_Labels')"
                :interactiveImage="interactiveImage"
                :loading="loadingData"
            />
            <InteractiveImage_Introduction
                v-show="interactiveImage.volets.isActiveComponent('InteractiveImage_Introduction')"
                :interactiveImage="interactiveImage"
            />
            <InteractiveImage_Image
                v-if="interactiveImage.volets.isActiveComponent('InteractiveImage_Image')"
                :interactiveImage="interactiveImage"
            />
            <InteractiveImage_Chapters
                v-show="interactiveImage.volets.isActiveComponent('InteractiveImage_Chapters')"
                :interactiveImage="interactiveImage"
            />
        </template>
        <template v-slot:footer>
            <Structure_Popup v-if="interactiveImage.isNew()" class="fixed small">
                <template v-slot:popup-header>
                    <div class="title-h1 p-1">
                        {{$t('New Interactive Image')}}
                    </div>
                </template>
                <template v-slot:popup-content>
                    <input-text v-model="interactiveImage.name" ref="input-create-name" :placeholder="$t('Name:')"/>
                    <input-media :label="$t('Base Image')" v-model="interactiveImage.base_image" :storieId="interactiveImage.getStoryId()" required @change="newBaseImageUpdated = true"/>
                </template>
                <template v-slot:popup-footer>
                    <div class="flex justify-end p-1">
                        <btn link active @click="interactiveImage.ongletClose()">
                            {{$t('Cancel')}}
                        </btn>
                        <btn icon border @click="valideNew()">
                            <i class="fal fa-plus"></i> {{$t('Create')}}
                        </btn>
                    </div>
                </template>
            </Structure_Popup>
        </template>
    </Structure_TabsRight>
</template>

<script>
import InteractiveImage_Header from './InteractiveImage_Header'
import InteractiveImage_Content from './InteractiveImage_Content'
import InteractiveImage_Labels from './InteractiveImage_Labels'
import InteractiveImage_Chapters from './InteractiveImage_Chapters'
import LinkContent from '../../modules/links/LinkContent'
import InteractiveImage_Functions from './InteractiveImage_Functions'
import Events from '../../events/events'
import {interactiveImage} from '@/class/interactive-image/interactiveImage'
import events from '../../events/events'
import InteractiveImage_Introduction from '@/views/interactives-images/InteractiveImage_Introduction'
import InteractiveImage_Image from '@/views/interactives-images/InteractiveImage_Image'
import InputText from '@/modules/input/input-text'
import Btn from '@/modules/buttons/btn'
import upload from '@/class/upload'
import InputMedia from '@/modules/input/input-media'
import tools from '@/class/tools'
import onglet, {saveContentOnglet} from '@/class/onglets/onglet'
import Structure_TabsRight from '@/views/structures/Structure_TabsRight'
import Template from '@/layouts/Template'
import Structure_Popup from '@/views/structures/Structure_Popup'
import nav from '@/class/nav/nav'

export default {
  name: 'InteractiveImage',
  components: {
    Structure_Popup,
    Template,
    Structure_TabsRight,
    InputMedia,
    Btn,
    InputText,
    InteractiveImage_Image,
    InteractiveImage_Introduction,
    InteractiveImage_Functions,
    LinkContent,
    InteractiveImage_Chapters,
    InteractiveImage_Labels,
    InteractiveImage_Content,
    InteractiveImage_Header,
    Events
  },
  data () {
    return {
      routeId: '',
      interactiveImage: new interactiveImage(),

      loadingData: false,
      help: true,

      newBaseImageUpdated:false,

      saveState:''
    }
  },
  methods: {
    async start () {
      this.interactiveImage = new interactiveImage()

      this.interactiveImage.historyClear()

      this.loadingData = true
      this.help = true

      const interactiveImageId = this.$route.params.id || 0
      const storyId = this.$route.params.storyId || 0
      this.loadingData = true

      // si l'onglet est déjà créé et que les données sont en cache

      if (saveContentOnglet.objectExist(this.interactiveImage.objectType, interactiveImageId) && interactiveImageId > 0) {

        this.interactiveImage = saveContentOnglet.objectGet(this.interactiveImage.objectType, interactiveImageId)

        // this.interactiveImage.ongletAdd();
        nav.add(this.interactiveImage)

        if (this.interactiveImage.typeGet() === 'boundingzoom') {
          this.interactiveImage.boundinZoneShow()
        }

        await this.$nextTick()
        this.loadingData = false

        return
      }

      this.interactiveImage.setStoryId(parseInt(storyId))

      if (interactiveImageId > 0) {
        console.log(`- id : ${  this.$route.params.id}`)
        this.interactiveImage.setId(interactiveImageId)
      } else {
        console.log(this.interactiveImage.isNew())
        console.log('- create new')
        this.$refs['input-create-name'].$refs['input'].focus()
        this.$refs['input-create-name'].$refs['input'].select()
      }

      this.interactiveImage.ongletSet()

      try {
        await this.interactiveImage.load()

        this.interactiveImage.historyAdd()
        nav.add(this.interactiveImage)
        // this.interactiveImage.ongletAdd();
        this.loadingData = false

        await this.storageUpdate()

      } catch (e) {
        console.log(e)
        this.loadingData = false
      }
    },
    searchLabel (word) {
      console.log(`search : ${  word}`)
    },
    undo () {
      if (this.interactiveImage.historyUndo()) {
        this.loadingData = true
        this.$nextTick().then(() => this.loadingData = false)
      }
    },
    redo () {
      if (this.interactiveImage.historyRedo()) {
        this.loadingData = true
        this.$nextTick().then(() => this.loadingData = false)
      }
    },
    unselect () {
      this.interactiveImage.labelUnselect()
      this.interactiveImage.labelUnedit()
      this.interactiveImage.chaptersGet().map(chapter => chapter.unedit())
    },
    voletSetActive (key) {

      if (key === 3 && this.interactiveImage.volets.currentVoletKey === 3) return

      // si on clique sur Image on affiche la boundingzone
      if (key === 3) {
        this._prevType = this.interactiveImage.typeGet()
        this.interactiveImage.boundinZoneShow()
        // si on est dans Image
      } else if (this.interactiveImage.volets.currentVoletKey === 3) {
        this.interactiveImage.labelUnselect()
        this.interactiveImage.labelUnedit()
        if (!this._prevType) this._prevType = 'all'
        this.interactiveImage.currentType = this._prevType
      }

      this.interactiveImage.volets.setActive(key)
    },
    valideNew () {
      if (this.interactiveImage.name === '' || this.interactiveImage.base_image.id === '' || !this.newBaseImageUpdated) {
        return
      }

      this.loadingData = true

      // let thisOnglet = new onglet().setData(tools.clone(this.interactiveImage.ongletGet()))
      const img = new Image
      img.src = this.interactiveImage.base_image.media

      img.onload = async () => {

        this.interactiveImage.setDataReq({
          width : img.width,
          height : img.height,
          bounding_box : [[(img.width - (img.height / 2)) / 2, 0], [((img.width - (img.height / 2)) / 2 + (img.height / 2)), img.height]],
          type : 'pan_zoom'
        })

        this.interactiveImage.getChapter(0).base_image.id = this.interactiveImage.base_image.id
        if (!await this.interactiveImage.save(true)) {
          // this.interactiveImage.ongletClose(thisOnglet);
          this.loadingData = false
          return
        }
        // this.interactiveImage.ongletClose(thisOnglet);
        await this.$router.push(this.interactiveImage.getRoute())
        this.loadingData = false
      }

    },
    async storageUpdate () {
      saveContentOnglet.objectSave(this.interactiveImage)
    }
  },
  watch: {
    'interactiveImage.volets.currentVoletKey' () {
      // si on change d'onglet et qu'on a un chapitre en cours de création on le cancel
      this.interactiveImage.chapterGetEditing().unedit()
    }
  },
  mounted () {
    console.log('----------- InteractiveImage Mounted -----------')

    window.addEventListener('keydown', this.keydown)

    this.start()

    // this.events.$on("interactive-image:keydown:save",this.saveAll)
    events.$on('body:keydown:undo', this.undo)
    events.$on('body:keydown:redo', this.redo)
    events.$on('body:click:dblclick', this.unselect)
    events.$on('interactive-image:loading', (toggle) => {
      this.loadingData = toggle
    })
    events.$on('body:history:save', () => {
      this.interactiveImage.historyAdd()
    })

    events.$on('interactive-image:storage:update', this.storageUpdate)

  },
  destroyed () {

    console.log('----------- InteractiveImage Destroy -----------')

    window.removeEventListener('keydown', this.keydown)

    events.$off('body:history:save')
    events.$off('body:keydown:undo')
    events.$off('body:keydown:redo')
    events.$off('body:click:dblclick')
    events.$off('interactive-image:loading')

    events.$off('interactive_image:storage:update', this.storageUpdate)

  }
}
</script>
